import { hashPassword } from './hash';
import { apiToken, uid } from './id';
import { applyRemoteAccount, isMysqlApi, pullAccount } from './cloud';
import { ensureDemoSites, replaceSiteTraffic, seedAllDemoSites } from './seed';
import {
  addUser,
  getSessionUserId,
  getSitesByUser,
  getUserByEmail,
  getUserById,
  isStoreReady,
  markStoreReady,
  setSessionUserId,
} from './store';

const SEED_VER = '4';

function seedVersion(): string {
  try {
    return localStorage.getItem('sf_seed_ver') || '';
  } catch {
    return '';
  }
}

function markSeedVersion() {
  try {
    localStorage.setItem('sf_seed_ver', SEED_VER);
  } catch {
    /* ignore */
  }
}

export async function bootstrapStore() {
  if (await isMysqlApi()) {
    const id = getSessionUserId();
    const user = id ? getUserById(id) : undefined;
    if (user?.apiToken) {
      const remote = await pullAccount(user.apiToken);
      if (remote?.unauthorized) setSessionUserId(null);
      else if (remote?.user) applyRemoteAccount(remote.user, remote.sites || []);
    }
    if (!isStoreReady()) markStoreReady();
    return;
  }

  if (import.meta.env.DEV) {
    await seedLocalPreview();
  }

  if (!isStoreReady()) markStoreReady();
}

async function seedLocalPreview() {
  const email = 'local@localhost';
  const password = 'localdev';
  if (!getUserByEmail(email)) {
    const user = {
      id: uid(),
      email,
      passwordHash: await hashPassword(password),
      createdAt: new Date().toISOString(),
      apiToken: apiToken(),
    };
    addUser(user);
    ensureDemoSites(user.id);
    seedAllDemoSites(user.id);
    markSeedVersion();
  } else if (seedVersion() !== SEED_VER) {
    const user = getUserByEmail(email);
    if (user) {
      const sites = ensureDemoSites(user.id);
      sites.forEach((site) => replaceSiteTraffic(site, 0));
      seedAllDemoSites(user.id);
    }
    markSeedVersion();
  } else {
    const user = getUserByEmail(email);
    if (user) {
      const before = getSitesByUser(user.id).length;
      const sites = ensureDemoSites(user.id);
      if (sites.length > before) seedAllDemoSites(user.id);
    }
  }
}
